export const objectMap = (obj: Object, fn: Function) => {
  Object.fromEntries(
    Object.entries(obj).map(([key, value], index) => [
      key,
      fn(value, key, index),
    ])
  );
};

export enum ObjReducerOptions {
  optValue,
  optArray,
  optIgnore,
}

// export type ObjReducerMap = {
//   [key: string]: ObjReducerOptions | ObjReducerMap;
// };
// /**
//  * Search an object for keys result set for items defined by the structure
//  * @param {JavaObject} searchObj  This is the GraphQL object you are searching, it can be at any level of the result set.
//  * @param {JavaObject} structure This is an object that defines the return structure.  Each section should be set to 'value', 'array' or an substructure.
//  * @param {Boolean} ignoreRepeats If set to true, on single return elements it will ignore repeated instances of the value
//  *   }
//  */
// export const reduceGraphQLElements = (
//   searchObj: object,
//   structure: ObjReducerMap,
//   ignoreRepeats: boolean
// ) => {
//   console.log({ searchObj });
//   const retObj = assignValue({}, searchObj, structure, ignoreRepeats, 'root: ');

//   return retObj;
// };

// const assignValue = (retObj, searchObj, structure, ignoreRepeats, fullPath) => {
//   // console.log({retObj : Object.assign({},retObj), searchObj, structure, fullPath});

//   if (typeof structure == 'string') {
//     if (structure == redQLIgnore) return retObj;

//     if (structure == redQLValue) {
//       if (isUndefined(retObj)) return searchObj;
//       //found it
//       else if (ignoreRepeats) return retObj;
//       //return the previously set value
//       else
//         throw new Error(
//           `Object unexpectedly reassigned value from ${fullPath}\n\n${searchObj}\n\n ${structure}`
//         ); //Unexpected situation.
//     }
//     if (structure == redQLArray) {
//       if (isUndefined(retObj)) retObj = [];
//       else if (!Array.isArray(retObj))
//         throw new Error(
//           `Unexpected ${typeof structure} where return value is not an array when expected from ${fullPath} `
//         );
//       retObj.push(searchObj);
//       return retObj;
//     }
//     throw new Error("Unexpected definition, either specify 'value' or 'array'");
//   } else if (
//     structure != null &&
//     !Array.isArray(structure) &&
//     typeof structure == 'object'
//   ) {
//     retObj = searchSection(
//       retObj || {},
//       searchObj,
//       structure,
//       ignoreRepeats,
//       fullPath
//     );
//     return retObj;
//   } else {
//     throw new Error(
//       `Structure path reached ${fullPath}, structure not properly defined though.`
//     );
//   }
// };

// const searchSection = (
//   retObj,
//   searchObj,
//   structure,
//   ignoreRepeats,
//   fullPath
// ) => {
//   if (
//     isUndefined(searchObj) ||
//     searchObj == {} ||
//     searchObj == null ||
//     typeof searchObj != 'object'
//   )
//     return retObj;

//   //If the search element is an array search through the array for the keys.
//   if (Array.isArray(searchObj)) {
//     retObj = searchObj.reduce((res, element, index) => {
//       return searchSection(
//         res,
//         element,
//         structure,
//         ignoreRepeats,
//         `${fullPath}[${index}]`
//       );
//     }, retObj); //! initial value.
//     return retObj;
//   }

//   const matchKeys = Object.keys(structure);

//   if (
//     !isUndefined(searchObj.fieldGroupName) &&
//     matchKeys.includes(searchObj.fieldGroupName)
//   ) {
//     retObj[searchObj.fieldGroupName] = assignValue(
//       retObj[searchObj.fieldGroupName],
//       searchObj,
//       structure[searchObj.fieldGroupName],
//       ignoreRepeats,
//       `${fullPath} <key: ${searchObj.fieldGroupName}>`
//     );
//   } else {
//     const searchKeys = Object.keys(searchObj);

//     searchKeys.forEach((key) => {
//       if (matchKeys.includes(key)) {
//         retObj[key] = assignValue(
//           retObj[key],
//           searchObj[key],
//           structure[key],
//           ignoreRepeats,
//           `${fullPath}.${key}`
//         );
//       } else {
//         retObj = searchSection(
//           retObj,
//           searchObj[key],
//           structure,
//           ignoreRepeats,
//           `${fullPath}.${key}`
//         );
//       }
//     });
//   }
//   return retObj;
// };
